if (document.body.contains(document.querySelector('.filter_bar'))) {
  var offsetTop = document.querySelector('.footer').offsetTop - 500;
  window.addEventListener('scroll', () => {
    if (window.scrollY > 100 && window.scrollY < offsetTop) {
      document.querySelector('.filter_bar_head').classList.add('show');
    } else {
      document.querySelector('.filter_bar_head').classList.remove('show');
    }
  });
}

//menu button
if (document.body.contains(document.querySelector('.filter-btn'))) {
  document.querySelector('.filter-btn').addEventListener('click', (event) => {
    document.querySelector('.filter_bar_filter').classList.toggle('show');
  });
}

if (document.body.contains(document.querySelector('.sort-btn'))) {
  document.querySelector('.sort-btn').addEventListener('click', (event) => {
    document.querySelector('.filter_bar_sort').classList.add('show');
  });
}

if (document.body.contains(document.querySelector('.btn-close'))) {
  document.querySelector('.btn-close').addEventListener('click', (event) => {
    document.querySelector('.filter_bar_filter').classList.remove('show');
  });
}

if (document.body.contains(document.querySelector('.btn-close01'))) {
  document.querySelector('.btn-close01').addEventListener('click', (event) => {
    document.querySelector('.filter_bar_sort').classList.remove('show');
  });
}
